import { apiBuilder, prefixApi } from "@zodios/core";
import { z } from "zod";

// stage-stats

const queryStageSchema = z.object({
  category: z.object({
    id: z.number(),
    name: z.string(),
    market_place: z.string(),
  }),
  stages: z.array(
    z.object({
      stage: z.number().nullable(),
      stage_name: z.string().nullable(),
      queries: z.array(z.string()),
    }),
  ),
});

export const queryStages = prefixApi(
  "/api",
  apiBuilder({
    alias: "getquerystages",
    method: "get",
    path: "/category-stage-review/:category_id",
    parameters: [
      {
        name: "category_id",
        type: "Path",
        schema: z.string(),
        description: "Category ID",
      },
      {
        name: "start",
        type: "Query",
        schema: z.string().nullable(),
        description: "start date in YYYY-MM-DD format",
      },
      {
        name: "end",
        type: "Query",
        schema: z.string().nullable(),
        description: "end date in YYYY-MM-DD format",
      },
      {
        name: "group",
        type: "Query",
        schema: z.string().nullable(),
        description: "group",
      },
    ],
    status: 200,
    response: queryStageSchema,
  }).build(),
);
